// extracted by mini-css-extract-plugin
export var gif = "_cb-0";